import React, { useState, useEffect,useRef, useContext } from "react";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import HomeIcon from "@mui/icons-material/Home";
import ArticleIcon from "@mui/icons-material/Article";
import NotificationsIcon from "@mui/icons-material/Notifications";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { flag, smalllogo1 } from "../iconsImports";
import { Corp_Role } from "../_nav";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import AuthContext from "../store/AuthContext";
import { maleAvatar, femaleAvatar } from "../iconsImports";
import { Box, Typography } from "@mui/material";
import { Email, Phone } from "@mui/icons-material";
import { getFirmEmail } from "../theme/setThemeColor";

const menuItems = [
  { label: "Dashboard", icon: <HomeIcon />, path: "/sidepage/page-one" },
  { label: "Services", icon: <ArticleIcon />, path: "/sidepage/page-two" },
  { label: "Management", icon: <ArticleIcon />, path: "/sidepage/page-three" },
  { label: "Protocol", icon: <ArticleIcon />, path: "/sidepage/page-four" },
  { label: "Transfer", icon: <ArticleIcon />, path: "/sidepage/page-five" },
];
const APPBAR_HEIGHT = 64;
const MOBILE_BREAKPOINT = 768;
const SIDEBAR_WIDTH = 250;
const COLLAPSED_SIDEBAR_WIDTH = 80;

const SideBar = () => {
  const location = useLocation();
    const navigate = useNavigate();
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_BREAKPOINT);
  const [isHovering, setIsHovering] = useState(false);
const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);
    const authCtx = useContext(AuthContext);
  const user = authCtx && authCtx.user;
  const handleResize = () => {
    const mobile = window.innerWidth <= MOBILE_BREAKPOINT;
    setIsMobile(mobile);
    if (!mobile) {
      setIsSidebarOpen(false); // Start collapsed on desktop
    }
  };
 const handleLogout = () => {
    authCtx.logout();
    // setAnchorEl(null);
    navigate("/login");
  };
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    if (isMobile) {
      setIsSidebarOpen(false);
    }
  };
useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(event.target)) {
        setIsProfileMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const toggleProfileMenu = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };


  const handleSidebarHover = (hovering) => {
    if (!isMobile) {
      setIsHovering(hovering);
      setIsSidebarOpen(hovering);
    }
  };

  // Calculate current sidebar width based on state
  const getSidebarWidth = () => {
    if (isMobile) {
      return isSidebarOpen ? SIDEBAR_WIDTH : 0;
    }
    return isHovering || isSidebarOpen ? SIDEBAR_WIDTH : COLLAPSED_SIDEBAR_WIDTH;
  };
 const profileMenuStyles = `
    .profile-menu {
      position: absolute;
      top: ${APPBAR_HEIGHT + 10}px;
      right: 20px;
      background-color: white;
      border-radius: 4px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      width: 200px;
      z-index: 110;
      overflow: hidden;
      display: ${isProfileMenuOpen ? 'block' : 'none'};
    }
    
    .profile-menu-item {
      display: flex;
      align-items: center;
      padding: 12px 16px;
      cursor: pointer;
      color: #333;
      text-decoration: none;
      transition: background-color 0.2s;
    }
    
    .profile-menu-item:hover {
      background-color: #f5f5f5;
    }
    
    .profile-menu-icon {
      margin-right: 12px;
      color: #666;
    }
    
    .profile-image-wrapper {
      position: relative;
      cursor: pointer;
    }
  `;
  return (
    <>
      <style>{`
              ${profileMenuStyles}

        /* Base styles */
        body {
          margin: 0;
          padding: 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        }

        .layoutContainer {
          display: flex;
          min-height: 100vh;
        }

        /* Sidebar styles */
        .sidebar {
          position: relative;
          width: ${getSidebarWidth()}px;
          background-color: #1D2029;
          box-shadow: 2px 0 4px rgba(0, 0, 0, 0.1);
          z-index: 90;
          overflow-y: auto;
          transition: width 0.3s ease;
          height: auto;
          display: flex;
          flex-direction: column;
          flex-shrink: 0;
        }

        .sidebar-header {
          display: flex;
          align-items: center;
          padding: 20px;
          height: ${APPBAR_HEIGHT}px;
          border-bottom: 1px solid #eee;
          min-height: ${APPBAR_HEIGHT}px;
        }

        .sidebar-logo {
          width: 30px;
          height: 30px;
        }

        .sidebar-title {
          margin-left: 10px;
          font-weight: bold;
          white-space: nowrap;
          color: #fff;
          opacity: ${isHovering || isSidebarOpen ? 1 : 0};
          transition: opacity 0.2s ease;
        }

        .menu-list {
          list-style: none;
          padding: 0;
          margin: 0;
          flex: 1;
          overflow-y: auto;
        }

        .menuItem {
          margin: 4px 0;
        }

        .menuLink {
          display: flex;
          align-items: center;
          padding: 12px 20px;
          text-decoration: none;
          color: #333;
          transition: background-color 0.2s;
          white-space: nowrap;
          overflow: hidden;
        }

        .menuLink:hover {
          background-color: #f5f5f5;
        }

        .menuLink.active {
          background-color: #e3f2fd;
          color: #1976d2;
        }

        .menu-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          margin-right: ${isHovering || isSidebarOpen ? '16px' : '0'};
          flex-shrink: 0;
          transition: margin-right 0.3s ease;
        }

        .icon-img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }

        .menu-text {
          opacity: ${isHovering || isSidebarOpen ? 1 : 0};
          transition: opacity 0.2s ease;
        }

        /* AppBar styles */
        .appBar {
          position: fixed;
          top: 0;
          left: ${getSidebarWidth()}px;
          right: 0;
          height: ${APPBAR_HEIGHT}px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 20px;
          background-color: #fff;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
          z-index: 100;
          transition: left 0.3s ease;
        }

        .appBar-left {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .appBar-right {
          display: flex;
          align-items: center;
          gap: 16px;
        }

        .hamburger {
          background: none;
          border: none;
          cursor: pointer;
          font-size: 24px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #333;
        }

        .circleImage {
          width: 36px;
          height: 36px;
          border-radius: 50%;
          object-fit: cover;
        }

        /* Content styles */
        .contentWrapper {
          flex: 1;
          transition: margin-left 0.3s ease;
          box-sizing: border-box;
          min-height: 100vh;
          padding-top: ${APPBAR_HEIGHT}px;
          padding-left: 16px;
          padding-right: 16px;
        }

        /* Mobile specific styles */
        @media (max-width: ${MOBILE_BREAKPOINT}px) {
          .sidebar {
            position: fixed;
            transform: translateX(-100%);
            width: ${SIDEBAR_WIDTH}px;
            transition: transform 0.3s ease;
          }

          .sidebar.open {
            transform: translateX(0);
          }

          .appBar {
            left: 0;
          }

          .contentWrapper {
            margin-left: 0;
          }

          .sidebar-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.5);
            z-index: 80;
          }
        }
      `}</style>

      <div className="layoutContainer">
        {/* Sidebar */}
        <aside
          className={`sidebar ${isSidebarOpen ? "open" : ""} ${isMobile ? "mobile" : "desktop"}`}
          onMouseEnter={() => handleSidebarHover(true)}
          onMouseLeave={() => handleSidebarHover(false)}
        >
          <div className="sidebar-header">
            <img src={smalllogo1} alt="Logo" className="sidebar-logo" />
            <span className="sidebar-title">Camel</span>
          </div>

          <ul className="menu-list">
            {Corp_Role.map((item, index) => (
              <li key={index} className="menuItem">
                <Link
                  to={item.to}
                  className={`menuLink ${location.pathname === item.to ? "active" : ""}`}
                  onClick={closeSidebar}
                >
                  <span className="menu-icon">
                    {typeof item.icon === "string" ? (
                      <img src={item.icon} alt={item.title} className="icon-img" />
                    ) : (
                      item.icon
                    )}
                  </span>
                  <span className="menu-text">{item.title}</span>
                </Link>
              </li>
            ))}
          </ul>
        </aside>

        {/* Overlay for mobile when sidebar is open */}
        {isMobile && isSidebarOpen && (
          <div className="sidebar-overlay" onClick={closeSidebar} />
        )}

        {/* AppBar and Content */}
        <div style={{ flex: 1 }}>
          {/* AppBar */}
          <div className="appBar">
            <div className="appBar-left">
              {isMobile && (
                <button className="hamburger" onClick={toggleSidebar}>
                  {isSidebarOpen ? <CloseIcon /> : <MenuIcon />}
                </button>
              )}
              <span className="appBar-title">Camel Dashboard</span>
                 <Box
                            sx={{
                              padding: "5px 6px 5px 4px",
                              backgroundColor: "#ffebee",
                              borderRadius: "8px",
                              display: "flex",
                              alignItems: "center",
              
                              width: { lg: "180px", sm: "150px", xs: "150px" },
                              border: "2px solid #1D2029",
                              overflow: "hidden",
                            }}
                          >
          <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          marginLeft: "8px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#212b5a",
                            fontSize: "10px",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Phone sx={{ color: "#1D2029", fontSize: "14px", mr: 0.5 }} />
        
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "bold",
                              marginLeft: "4px",
                            }}
                          >
                            9355128199,011 45794784
                          </span>
                        </Typography>
        
                        <Typography
                          variant="body2"
                          sx={{
                            color: "#212b5a",
                            fontSize: "10px",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            mt: "0.5",
                          }}
                        >
                          <Email sx={{ color: "#1D2029", fontSize: "14px", mr: 0.5 }} />
        
                          <span
                            style={{
                              fontSize: "10px",
                              fontWeight: "bold",
                              marginLeft: "4px",
                            }}
                          >
                            {getFirmEmail()}
                          </span>
                        </Typography>
                      </Box>
                      </Box>
            </div>
            <div className="appBar-right">
        {/* <img src={flag} alt="India Flag" className="circleImage" /> */}
        <span className="bellIcon">
          <NotificationsIcon style={{ fontSize: "24px", color: "#1f1f1f" }} />
        </span>
        <div className="profile-image-wrapper" ref={profileMenuRef}>
          <img

             src={user.gender === "F" ? femaleAvatar : maleAvatar}
            alt="Profile"
            className="circleImage"
            onClick={toggleProfileMenu}
          />
         <div className="profile-menu">
  <Link 
    to="myprofile" 
    className="profile-menu-item"
    onClick={() => setIsProfileMenuOpen(false)}
  >
    <AccountCircleIcon className="profile-menu-icon" />
    <span>My Profile</span>
  </Link>
  
  <div className="profile-menu-item">
    <SettingsIcon className="profile-menu-icon" />
    <span>Settings</span>
  </div>
  
  <div 
    className="profile-menu-item"
               onClick={handleLogout}

  >
    <LogoutIcon className="profile-menu-icon" />
    <span>Logout</span>
  </div>
</div>
          </div>
          </div>
          </div>

          {/* Main content */}
          <div className="contentWrapper">
            <main className="mainContent">
              <Outlet />
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
